import React from "react";
import Keen from "keen-js";

class Chart extends React.Component {
  constructor(props) {
    super(props);
    this.chart = null;
  }

  componentDidMount() {
    this.componentWillUpdate(this.props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const hasNewData =
      nextProps.data !== this.props.data ||
      nextProps.placeholder !== this.props.placeholder ||
      nextProps.chartOptions !== this.props.chartOptions;
    return hasNewData;
  }

  componentWillUpdate(newProps) {
    if (!this.chart) {
      this.chart = new Keen.Dataviz().el(this.el);
    }

    let { chart } = this;
    let { data, placeholder, ...rest } = newProps;

    if (!chart) {
      return;
    }

    if (placeholder) {
      rest.type = "message";
    }

    chart.attributes(rest).prepare();

    if (data) {
      chart.data(data).render();
    } else if (placeholder) {
      chart.render().message(placeholder);
    }
  }

  render() {
    const { placeholder } = this.props;
    return (
      <div
        ref={r => {
          this.el = r;
        }}
        className={placeholder && "Chart--has-placeholder"}
      />
    );
  }
}

Chart.defaultProps = {
  type: "line",
  height: 300
};

export default Chart;



// WEBPACK FOOTER //
// ./src/app/components/partials/charts/chart.jsx